import { ArrowRight, Check, ChevronRight } from "lucide-react";
import { cn } from "@/utils/helpers";

/**
 * The idea a post is built on, above its creative brief (library Calendar /
 * Idea reference card; on a phone Picked idea row · Phone): a check, "From
 * idea 2", the idea's title and Open idea, which goes back to the Concept tab.
 */
export default function IdeaReferenceCard({
  index,
  title,
  phone = false,
  onOpen,
  className,
}: {
  /** The idea's place among the three, from 0. */
  index: number;
  title: string;
  phone?: boolean;
  onOpen: () => void;
  className?: string;
}) {
  if (phone) {
    return (
      <button
        type="button"
        onClick={onOpen}
        aria-label={`From idea ${index + 1}: ${title}. Open the idea`}
        className={cn(
          "flex w-full items-center gap-2.5 rounded-card bg-co-surface px-3 py-2.5 text-left outline-none focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-co-accent",
          className,
        )}
      >
        <Check className="size-[15px] shrink-0 text-co-text2" strokeWidth={2} aria-hidden="true" />
        <span className="min-w-0 flex-1 truncate text-[14px] font-semibold leading-5 text-co-text">{title}</span>
        <ChevronRight className="size-[15px] shrink-0 text-co-muted" strokeWidth={2} aria-hidden="true" />
      </button>
    );
  }
  return (
    <div
      className={cn(
        "flex min-h-10 items-center gap-3 rounded-card bg-co-surface px-3.5 py-2.5 shadow-[inset_0_0_0_1px_var(--co-line2)]",
        className,
      )}
    >
      <Check className="size-4 shrink-0 text-co-text2" strokeWidth={2} aria-hidden="true" />
      <span className="shrink-0 text-[13px] text-co-muted">From idea {index + 1}</span>
      <span className="min-w-0 flex-1 truncate text-[14px] font-semibold text-co-text">{title}</span>
      <button
        type="button"
        onClick={onOpen}
        className="inline-flex shrink-0 items-center gap-1.5 text-[13px] font-medium text-co-text2 outline-none transition-colors hover:text-co-text focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-co-accent"
      >
        Open idea
        <ArrowRight className="size-3.5" strokeWidth={1.8} aria-hidden="true" />
      </button>
    </div>
  );
}
